import httpClient from './httpClient'

const path = '/player/template_muted_indicator'

export default {
  async getPersonalized() {
    const ret = await httpClient.get(`${path}`)
    return ret
  },

  async createPersonalized(data) {
    const ret = await httpClient.post(`${path}`, data)
    return ret
  },

  async updatePersonalized(id, data) {
    const ret = await httpClient.put(`${path}/${id}`, data)
    return ret
  },

  async deletePersonalized(id, params) {
    const ret = await httpClient.delete(`${path}/${id}`, { params })
    return ret
  },
}
